import { render, staticRenderFns } from "./EsamiSpecialisticiEdit.vue?vue&type=template&id=5bea59fb&scoped=true"
import script from "./EsamiSpecialisticiEdit.vue?vue&type=script&lang=js"
export * from "./EsamiSpecialisticiEdit.vue?vue&type=script&lang=js"
import style0 from "./EsamiSpecialisticiEdit.vue?vue&type=style&index=0&id=5bea59fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bea59fb",
  null
  
)

export default component.exports